import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { Config } from "../core/config/config";
import { HTTPService } from "../core/util/httpManager";
import React from "react";
export default class EditIndividualFieldsApp extends React.Component<any, any> {
    common = new AppHelper();
    areCategoriesUsed: boolean = false;
    translations: any;
    constructor(props) {
        super(props);
        this.areCategoriesUsed = props.areCategoriesUsed;
        this.common.enableHooks = true;
        this.common.init(this);
        this.initApp();
    }

    private initApp = () => {
        this.props.context.translations = this.translations;
    }

    reloadFields = () => {
        HTTPService.get("EditIndividualFields/ReloadFields").then((result) => {
            window.location.href = Config.baseUrl + "EditIndividualFields/Index";
        })
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} titleProps={""} />;
    }
}